<template>
    <div class="phone_box">
        <span>{{ phone }}</span>
        <svg v-show="isswith && isPhone && !isShow" @click="change" t="1725431902763" class="icon"
            viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2328" width="200"
            height="200">
            <path
                d="M512 256c-168 0-329.6 106.4-384 256 54.4 149.6 216 256 384 256 167.2 0 330.4-106.4 384.8-256-55.2-149.6-217.6-256-384.8-256z m0 416c-88 0-160-72-160-160s72-160 160-160 160 72 160 160-72 160-160 160z m96-160c0 52.8-43.2 96-96 96s-96-43.2-96-96 43.2-96 96-96 96 43.2 96 96z"
                p-id="2329" fill="#8a8a8a"></path>
        </svg>
        <svg v-show="isswith && isPhone && isShow" @click="change" t="1725431940898" class="icon"
            viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3511" width="200"
            height="200">
            <path
                d="M253.6 679.2l109.6-109.6C356 552 352 532.8 352 512c0-88 72-160 160-160 20.8 0 40 4 57.6 11.2l82.4-82.4C607.2 264.8 560 256 512 256c-168 0-329.6 106.4-384 256 24 65.6 68.8 123.2 125.6 167.2z"
                p-id="3512" fill="#8a8a8a"></path>
            <path
                d="M416 512v4.8L516.8 416H512c-52.8 0-96 43.2-96 96zM770.4 344.8l163.2-163.2L888 136l-753.6 753.6 45.6 45.6 192.8-192.8A390.4 390.4 0 0 0 512 768c167.2 0 330.4-106.4 384.8-256-24-65.6-69.6-123.2-126.4-167.2zM512 672c-20 0-40-4-57.6-11.2l53.6-53.6h4.8c52.8 0 96-43.2 96-96v-4.8l53.6-53.6C668 472 672 492 672 512c0 88-72 160-160 160z"
                p-id="3513" fill="#8a8a8a"></path>
        </svg>
    </div>
</template>

<script lang="ts" setup>
import { ref, computed, watch } from 'vue';
const props = defineProps({
    text: {
        type: [String, Number]
    },
    isswith: {
        type: Boolean,
        default: true
    }
})
const isShow = ref(false)
const isPhone = ref(true)
const phone = ref()

watch(() => props.text, (newValue, oldValue) => {
    if (isShow.value) {
        phone.value = props.text
    } else {
        let phoneRegex = /^1[3-9]\d{9}$/
        if (phoneRegex.test(props.text as string)) {
            phone.value = props.text?.toString().replace(/(\d{3})\d{4}(\d{4})/, '$1***$2');
        } else {
            const length = newValue as string 

            const start = Math.floor((length.length - 4) / 2);
            const end = start + 4;
            phone.value = length.slice(0, start) + '****' + length.slice(end);
        }

    }

}, { immediate: true, deep: true })
const change = () => {
    isShow.value = !isShow.value
    if (isShow.value) {
        phone.value = props.text
    } else {
        let phoneRegex = /^1[3-9]\d{9}$/
        if (phoneRegex.test(props.text as string)) {
            phone.value = props.text?.toString().replace(/(\d{3})\d{4}(\d{4})/, '$1***$2');
        } else {
            const length = props.text as string 

            const start = Math.floor((length.length - 4) / 2);
            const end = start + 4;
            phone.value = length.slice(0, start) + '****' + length.slice(end);
        }
        // phone.value = props.text?.toString().replace(/(\d{3})\d{4}(\d{4})/, '$1***$2');
    }
}
</script>

<style lang="less">
.phone_box {
    svg {
        width: 20px;
        height: 20px;
        vertical-align: middle;
        margin-left: 5px;
        cursor: pointer;
    }
}
</style>